import React from 'react'

const Header = () => {
    return (
        <header className="header">
            <img src="http://www.army.mod.uk/media/4333/bgn-200-200.jpg" alt="" />
            <h1>Webdev Merni Examination Result</h1>
        </header>
    )
}

export default Header
